import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import BackgroundImage from '../assets/images/background.webp';

export const Wrapper = styled(motion.div)`
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;

    display: flex;
    width: 100%;
    pointer-events: none;
`;

interface TopNavProps {
    $bgImage?: string;
    $hideBackground?: boolean;
    $hideSearch?: boolean;
    $fullWidth?: boolean;
}

export const Background = styled.div<TopNavProps>`
    padding: 35px 40px 20px 40px;
    width: 100%;

    max-width: 1920px;
    margin: 0 auto;

    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    pointer-events: ${({ $hideSearch }) => ($hideSearch ? 'none' : 'auto')};

    background-repeat: no-repeat;
    background-size: 100vw 100vh;
    background-position: 0 0;
    background-attachment: fixed;
    background-color: #090719;

    ${({ $bgImage }) =>
        $bgImage
            ? css`
                  background-image: url(${$bgImage});
              `
            : css`
                  background-image: url(${BackgroundImage});
              `};

    ${({ $hideBackground }) =>
        $hideBackground &&
        css`
            background-image: none;
            background-color: transparent;
        `};

    ${({ $fullWidth }) =>
        $fullWidth &&
        css`
            max-width: 100%;
        `};
`;

export const LeftSide = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    pointer-events: all;
    width: 100%;

    gap: 20px;
`;

export const RightSide = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
`;

const baseButton = css`
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    pointer-events: all;

    backdrop-filter: blur(20px);

    display: flex;
    align-items: center;
    gap: 8px;

    height: 40px;
    padding: 0 20px;

    white-space: nowrap;
    user-select: none;

    transition:
        color 0.1s ease-in-out,
        box-shadow 0.1s ease-in-out;

    color: #fff;
    border: none;
    cursor: pointer;

    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    text-align: center;
    letter-spacing: -0.02em;

    span {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    &:hover {
        color: #fff;
        box-shadow:
            0 0 68px 0 rgb(255 255 255 / 5%) inset,
            0 0 0 1px rgb(255 255 255 / 5%) inset;
    }

    &:active {
        color: #fff;
    }
`;

export const Button = styled(Link)`
    ${baseButton}
`;

const NativeButton = styled.button`
    ${baseButton}
`;

export const WalletStatus = styled.div<{ $status: 'green' | 'red' }>`
    width: 7px;
    height: 7px;

    background: #1dff26;
    border-radius: 100%;

    ${({ $status }) =>
        $status === 'red' &&
        css`
            background: #ff0000;
        `}
`;

export const WalletButtonStyled = styled(NativeButton)<{ $forceFullSize?: boolean }>`
    ${({ $forceFullSize }) =>
        !$forceFullSize &&
        css`
            @media (max-width: 1468px) {
                width: 40px;
                padding: 0;

                display: flex;
                align-items: center;
                justify-content: center;

                position: relative;

                span {
                    display: none;
                }

                ${WalletStatus} {
                    position: absolute;
                    top: 1px;
                    right: 1px;
                }
            }
        `}
`;

export const SearchWrapper = styled.div`
    width: 100%;
    max-width: 437px;
    min-width: 166px;
`;
